import React from "react"
import { useSelector } from "react-redux"

const Header = ({ toggleSidebar, isSidebarOpen }) => {
  const { userDetails } = useSelector((state) => state.basicInformation)
  return (
    <div
      className={`header_wrapper shadow-sm d-lg-none ${
        isSidebarOpen ? "header_full" : ""
      }`}
    >
      <div
        className="toogle_wrapper d-inline-flex d-lg-none"
        onClick={toggleSidebar}
      >
        {isSidebarOpen ? (
          <i className="icon_main close_toggle"></i>
        ) : (
          <i className="icon_main navigation_toggle"></i>
        )}
      </div>
      <div className="profiledetails_head">
        <span className="account_user-avatar">
          <i
            className="avtar_nm"
            data-name={
              userDetails?.firstname.charAt(0) + userDetails?.lastname.charAt(0)
            }
          ></i>
        </span>
      </div>
    </div>
  )
}

export default Header
